<template>
    <div v-if="isShowable" max-width="500" :width="$vuetify.breakpoint.lgAndUp ? '50%' : '90%'" scrollable class="giftcard-ats-popup" :class="{ 'giftcard-ats-popup--active': shows }">
        <v-card>
            <v-img eager src="/images/giftcard/giftcard_kakao_popup.jpg">
                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                    <v-spacer />
                    <v-btn fab color="transparent" @click="shows=false" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                </v-app-bar>
            </v-img>
            <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px">
                <v-checkbox v-model="doNotOpenToday" color="#fff" label="오늘 하루 열지않음" hide-details="" class="white--text" @click="close"/>
                <!-- <v-btn text @click="shows = false" style="color: white; font-size: 16px" class="px-0"><v-icon small class="mr-1">mdi-close</v-icon>닫기</v-btn> -->
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            shows: false,
            giftcard: null,
            doNotOpenToday: false,
        };
    },
    methods: {
        close() {
            if (this.doNotOpenToday) {
                this.$cookies.set("topping_popup", "hidden", "1d");
            }
            this.shows = false;
        },
    },
    computed: {
        isShowable() {
            return false;
            return this.shows && this.giftcard.platform === "topping";
        },
    },
};
</script>

<style lang="scss" scoped>
.giftcard-ats-popup {
    position: fixed;
    max-width: calc(100% - 24px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(100%);
    z-index: 1000;
    animation: popup 0.6s;
}

@keyframes popup {
    from {
        transform: translate(-50%, -50%) scale(50%);
        opacity: 0;
    }
    to {
        transform: translate(-50%, -50%) scale(100%);
        opacity: 1;
    }
}

::v-deep {
    .v-label {
        color: #fff !important;
    }
}
</style>